import Vue from 'vue';
import Vuetify from 'vuetify';

// Import Vuetify locales
import sr from 'vuetify/lib/locale/sr-Cyrl';
import en from 'vuetify/lib/locale/en';
import hr from 'vuetify/lib/locale/hr';
import de from 'vuetify/lib/locale/de';
import fr from 'vuetify/lib/locale/fr';
import es from 'vuetify/lib/locale/es';
import it from 'vuetify/lib/locale/it';
import ru from 'vuetify/lib/locale/ru';
import tr from 'vuetify/lib/locale/tr';
import zh from 'vuetify/lib/locale/zh-Hans';
import uk from 'vuetify/lib/locale/uk'; // closest to mk
import sl from 'vuetify/lib/locale/sl'; // for si (Slovenia)

// Custom Serbian Latin locale (transliterated from Cyrillic)
const srLat = {
  badge: 'Značka',
  close: 'Zatvori',
  dataIterator: {
    noResultsText: 'Nisu pronađeni odgovarajući zapisi',
    loadingText: 'Učitavanje stavki...',
  },
  dataTable: {
    itemsPerPageText: 'Redova po stranici:',
    ariaLabel: {
      sortDescending: 'Sortirano opadajuće.',
      sortAscending: 'Sortirano rastuće.',
      sortNone: 'Nije sortirano.',
      activateNone: 'Aktiviraj da ukloniš sortiranje.',
      activateDescending: 'Aktiviraj da sortiraš opadajuće.',
      activateAscending: 'Aktiviraj da sortiraš rastuće.',
    },
    sortBy: 'Sortiraj po',
  },
  dataFooter: {
    itemsPerPageText: 'Stavki po stranici:',
    itemsPerPageAll: 'Sve',
    nextPage: 'Sledeća stranica',
    prevPage: 'Prethodna stranica',
    firstPage: 'Prva stranica',
    lastPage: 'Poslednja stranica',
    pageText: '{0}-{1} od {2}',
  },
  datePicker: {
    itemsSelected: '{0} izabrano',
    nextMonthAriaLabel: 'Sledeći mesec',
    nextYearAriaLabel: 'Sledeća godina',
    prevMonthAriaLabel: 'Prethodni mesec',
    prevYearAriaLabel: 'Prethodna godina',
  },
  noDataText: 'Nema dostupnih podataka',
  carousel: {
    prev: 'Prethodna slika',
    next: 'Sledeća slika',
    ariaLabel: {
      delimiter: 'Carousel slajd {0} od {1}',
    },
  },
  calendar: {
    moreEvents: 'Još {0}',
  },
  fileInput: {
    counter: '{0} fajlova',
    counterSize: '{0} fajlova ({1} ukupno)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Navigacija stranicama',
      next: 'Sledeća stranica',
      previous: 'Prethodna stranica',
      page: 'Idi na stranicu {0}',
      currentPage: 'Trenutna stranica, stranica {0}',
    },
  },
  rating: {
    ariaLabel: {
      icon: 'Ocena {0} od {1}',
    },
  },
};

// Bosnian locale (based on Serbian Latin with slight differences)
const bs = {
  ...srLat,
  dataTable: {
    ...srLat.dataTable,
    itemsPerPageText: 'Redova po stranici:',
  },
  dataFooter: {
    ...srLat.dataFooter,
    itemsPerPageText: 'Stavki po stranici:',
    nextPage: 'Sljedeća stranica',
    prevPage: 'Prethodna stranica',
    pageText: '{0}-{1} od {2}',
  },
};

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: {
      sr,
      rs: sr, // use same Serbian Cyrillic for rs
      'sr-lat': srLat, // Serbian Latin - custom locale
      'rs-lat': srLat, // use Serbian Latin for rs-lat
      en,
      hr,
      bs, // Bosnian - custom locale
      de,
      fr,
      es,
      it,
      ru,
      tr,
      zh,
      mk: uk, // Macedonian - use Ukrainian as closest Cyrillic
      si: sl, // Slovenian
      uz: en, // Uzbek - use English as fallback
    },
    current: 'sr',
  },
  theme: {
    themes: {
      light: {
        primary: '#fb6d3b',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        tertiary: "#fb6d3b"
      },
    },
  },
});

